import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import LesCouleurs from "@/views/LesCouleurs.vue";
import AdvertisingArtist from "@/views/AdvertisingArtist.vue";
import MovieVisual from "@/views/MovieVisual.vue";
import Profile from "@/views/Profile.vue";
import Couleurs from "@/views/Works.vue";
import NotFound from "@/views/NotFound.vue";
import store from "../store/index";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/les_couleurs",
    name: "LesCouleurs",
    component: LesCouleurs
  },
  {
    path: "/advertising_artist",
    name: "AdvertisingArtist",
    component: AdvertisingArtist
  },
  {
    path: "/movie_visual",
    name: "MovieVisual",
    component: MovieVisual
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile
  },
  {
    path: "/works",
    name: "Works",
    component: Couleurs
  },
  {
    path: "*",
    name: "404",
    component: NotFound
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.afterEach((to, from) => {
  // ページ遷移するときはメニューを閉じる
  // また、必ずページトップにスクロールさせる
  if (to.path !== from.path) {
    store.commit("invalidMenuState");
  }
});

export default router;
